export enum FundFamilyName {
    V = 'V',
    VI = 'VI',
    VII = 'VII',
    VIII = 'VIII',
    QIFI = 'QIF I',
    QIFII = 'QIF II',
    QCSI = 'QCS I',
    QCSII = 'QCS II',
    FCV = 'FCV',
    QCOI = 'QCO I',
    IX = 'IX'
}

export enum FundFamilyMainFundMember {
    QEPV = 'QEP V',
    QEPVI = 'QEP VI',
    QEPVII = 'QEP VII',
    QEPVIII = 'QEP VIII',
    QLCPI = 'QLCP I',
    QCSII = 'QCS-II',
    QEPIX = 'QEP IX'
}